import React from 'react';
import VisitConsult from './visitconsult';
import PhoneConsult from './phoneconsult';
import HappyTalkLogs from './happytalklogs';

const BookedList: React.FC<any> = (props) => {
    return (
        <div>
            <div style={{ marginBottom: "16px", color: "#c62828", fontSize: "13px", fontWeight: "bold" }}>
                * 모든 상담 인센티브는 해당 페이지에서 학생매칭이 되어야 지급됩니다.
            </div>
            <VisitConsult user={props.user} />
            <PhoneConsult user={props.user} />
            <HappyTalkLogs user={props.user} />
        </div>
    );
};

export default BookedList;
